// Single source of truth for figures that change over time.
// Update this block annually; the rest of the page reads from it.
export const CONFIG = {
  revenue: '¥41.5B',
  revenueNote: 'Year ended March 2026 (consolidated)',
  employees: '2,812',
  employeesNote: 'March 2025, consolidated',
  companies: '22',
  companiesNote: 'As of March 31, 2026',
  maDealsTotal: '16',
  maDealsSince: '2018',
  targetRevenue: '¥50B',
  targetFY: 'FY2028',
  founded: '1974',
  hq: 'Tokyo',
  currentFY: 'FY2026',
} as const;

export type Config = typeof CONFIG;
